import React from 'react'
import { useRouter } from 'next/router'
import { GridLogoIcon } from '@/components/icons'
import { CenteredArtworkScreen } from '@/shared/centered-artwork-screen'

interface ErrorScreenProps {
  statusCode?: number
}

const ErrorScreen: React.FC<ErrorScreenProps> = ({ statusCode }) => {
  const router = useRouter()
  const is404 = statusCode === 404

  const title = is404 ? 'Page Not Found' : 'An Error Occurred'
  const subtitle = is404
    ? "Sorry, we couldn't locate the page you requested. Please check the URL or go back."
    : 'There seems to be a problem within our system. Please refresh or reach out to api.support@gridverify.com.'

  return (
    <CenteredArtworkScreen>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '412px',
        height: '308px',
        padding: '24px 52px',
      }}
      >
        <h1 style={{
          fontSize: '28px',
          marginBottom: '8px',
        }}
        >
          {title}
        </h1>
        <div style={{
          marginBottom: '24px',
          fontFamily: 'Switzer',
          fontWeight: 'normal',
          color: 'var(--gray-3)',
          fontSize: '14px',
        }}
        >
          {subtitle}
        </div>
        {is404 && (
          <button
            type="button"
            onClick={() => router.back()}
            style={{
              marginBottom: '24px',
              padding: '8px 16px',
              fontFamily: 'Switzer',
              fontWeight: 600,
              fontSize: '14px',
              color: 'var(--gray-1)',
              backgroundColor: 'transparent',
              border: '1px solid var(--gray-5)',
              borderRadius: '8px',
              cursor: 'pointer',
              alignSelf: 'flex-start',
            }}
          >
            Go Back
          </button>
        )}
        <GridLogoIcon />
      </div>
    </CenteredArtworkScreen>
  )
}

export default ErrorScreen
